import { Nl2Br } from '@findy-code/yuffie/shared/nl2br';
import { Heading } from '@findy-code/yuffie/ui/heading';

import type { JobDescriptionCompanyAiUsageFragment } from '../../graphql';
import { Register } from '../register';
import styles from './company-ai-usage.module.scss';

type Props = {
  companyAiUsage: JobDescriptionCompanyAiUsageFragment;
  companyId: number;
  isLogin: boolean;
  jobDescriptionHash: string;
  onClickLink?: (label: string) => void;
};

/**
 * NOTE: SHORTはFULLを短く言い換えた時の言い回しとして扱っている
 * エンプラではSHORTを表示しているが、候補者側はFULLの内容を表示しているため、FE側で内容を変換している
 */
const AI_USAGE_ANSWER_OTHER_METHOD = {
  SHORT: '上記以外の方法で導入・活用を推進している',
  FULL: '研究開発やサービス提供、業務改善以外の目的で導入・活用している',
} as const;

export const CompanyAiUsage = ({
  companyAiUsage,
  companyId,
  isLogin,
  jobDescriptionHash,
  onClickLink,
}: Props) => {
  return (
    <div>
      <p className={styles.aiUsageDescription}>
        最新の情報についてはカジュアル面談や選考の中で確認ください。
      </p>
      <div>
        {isLogin ? (
          <div className={styles.aiUsageBoxContainer}>
            <div className={styles.aiUsageInnerContainer}>
              <div className={styles.aiUsageSection}>
                <Heading
                  as="h3"
                  className={styles.aiUsageHeading}
                  color="brandColor"
                  font="heading-m"
                >
                  生成AI技術/ツールの導入・活用状況
                </Heading>
                <div className={styles.aiUsageStatusContent}>
                  {companyAiUsage.companyAiUsageAnswers.map(
                    ({ companyAiUsageAnswerOption }) => (
                      <span key={companyAiUsageAnswerOption.label}>
                        {companyAiUsageAnswerOption.label ===
                        AI_USAGE_ANSWER_OTHER_METHOD.SHORT
                          ? AI_USAGE_ANSWER_OTHER_METHOD.FULL
                          : companyAiUsageAnswerOption.label}
                      </span>
                    )
                  )}
                </div>
              </div>
              <div className={styles.aiUsageSection}>
                <Heading
                  as="h3"
                  className={styles.aiUsageHeading}
                  color="brandColor"
                  font="heading-m"
                >
                  開発組織において公式に導入・活用されているAIツール・機能・技術
                </Heading>
                <div className={styles.aiUsageContent}>
                  {companyAiUsage.companyAiUsageSkills
                    .map(({ skill }) => skill.name)
                    .join(', ')}
                </div>
              </div>
              {companyAiUsage.comment && (
                <div className={styles.aiUsageSection}>
                  <Heading
                    as="h3"
                    className={styles.aiUsageHeading}
                    color="brandColor"
                    font="heading-m"
                  >
                    生成AI活用状況の詳細
                  </Heading>
                  <div>
                    <div className={styles.aiUsageContent}>
                      <Nl2Br addLink text={companyAiUsage.comment} />
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        ) : (
          <div>
            <div className={styles.aiUsageBoxRegisterContainer}>
              <div className={styles.aiUsageInnerContainer}>
                <div className={styles.aiUsageSection}>
                  <Heading
                    as="h3"
                    className={styles.aiUsageHeading}
                    color="brandColor"
                    font="heading-m"
                  >
                    生成AI技術/ツールの導入・活用状況
                  </Heading>
                  <div className={styles.aiUsageStatusContent}>
                    {companyAiUsage.companyAiUsageAnswers.map(
                      ({ companyAiUsageAnswerOption }) => (
                        <span key={companyAiUsageAnswerOption.label}>
                          {companyAiUsageAnswerOption.label ===
                          AI_USAGE_ANSWER_OTHER_METHOD.SHORT
                            ? AI_USAGE_ANSWER_OTHER_METHOD.FULL
                            : companyAiUsageAnswerOption.label}
                        </span>
                      )
                    )}
                  </div>
                </div>
                <div className={styles.aiUsageRegisterSection}>
                  <Heading
                    as="h3"
                    className={styles.aiUsageHeading}
                    color="brandColor"
                    font="heading-m"
                  >
                    開発組織において公式に導入・活用されているAIツール・機能・技術
                  </Heading>
                </div>
              </div>
            </div>
            <Register
              companyId={companyId}
              jobDescriptionHash={jobDescriptionHash}
              onClickLink={onClickLink}
            />
          </div>
        )}
      </div>
    </div>
  );
};
